module.exports = __webpack_public_path__ + "img/tu01.66dcebbe.jpg";